// EMPTY AT THE MOMENT

//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = (rule, cb) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.NewsLetterSubscriber', 'inited', (p, widget) => {
			const master_submitForm = widget.submitForm;

			widget.submitForm = (data, ...args) => callback().then(({ result, params }) => {
				if (result === true) {
					return master_submitForm.apply(widget, [
						{
							...data,
							...params
						},
						...args
					]);
				}
			});
		}, {
				sync: true,
				prefix: 'user_access_patch_newsletter_subscriber'
			});
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-newsletter-subscribe.es.js